export enum FIGURES {
	None = 0,
	Square = 1,
	Rectangle = 2,
	Trapezoid = 3,
	Triangular = 4,
	Polygon = 5,
}

export enum EDITED_MODE {
	'Немає' = 0,
	'Побудова фігури' = 1,
	'Пропорційна трансформація' = 2,
	'Трансформація за точками' = 3,
	'Накладання блоків' = 4,
}
